import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  empenhos: { content: [] },
  totalizador: {},
  tiposTransferencias: []
});

function emendaEmpenhosReducer(state = initialState, action) {
  switch (action.type) {
    case types.CONSULTA_EMENDA_EMPENHOS_START:
    case types.CONSULTA_EMENDA_EMPENHOS_TOTAL_START:
    case types.TIPO_TRANSFERENCIA_EMPENHOS_START: {
      return startLoad(state);
    }

    case types.CONSULTA_EMENDA_EMPENHOS_ERROR:
    case types.CONSULTA_EMENDA_EMPENHOS_TOTAL_ERROR:
    case types.TIPO_TRANSFERENCIA_EMPENHOS_ERROR: {
      return endLoad(state);
    }

    case types.CONSULTA_EMENDA_EMPENHOS_SUCCESS: {
      return endLoad(state.set('empenhos', fromJS(action.payload)));
    }

    case types.CONSULTA_EMENDA_EMPENHOS_TOTAL_SUCCESS: {
      return endLoad(state.set('totalizador', fromJS(action.payload)));
    }

    case types.TIPO_TRANSFERENCIA_EMPENHOS_SUCCESS: {
      return endLoad(state.set('tiposTransferencias', fromJS(action.payload)));
    }

    case types.RESET_CONSULTA_EMENDA_EMPENHOS: {
      return initialState;
    }
  }

  return state;
}

export default emendaEmpenhosReducer;
